import { BreakpointObserver } from '@angular/cdk/layout';
import { Injectable, NgZone } from '@angular/core';
import { Store } from '@ngrx/store';
import * as UiActions from './ui-state.actions';

@Injectable()
export class MobileQueryService {
  constructor(
    private store: Store,
    private breakpointObserver: BreakpointObserver,
    private ngZone: NgZone
  ) {
    // Set Media Queries
    breakpointObserver.observe('(max-width: 767px)').subscribe((result) => {
      if (result.matches) {
        setTimeout(() => this.ngZone.run(() => this.store.dispatch(UiActions.IsMobile())), 0);
      }
    });
    breakpointObserver.observe('(min-width: 768px) and (max-width: 1023px)').subscribe((result) => {
      if (result.matches) {
        setTimeout(() => this.ngZone.run(() => this.store.dispatch(UiActions.IsTablet())), 0);
      }
    });
    breakpointObserver.observe('(min-width: 1024px)').subscribe((result) => {
      if (result.matches) {
        setTimeout(() => this.ngZone.run(() => this.store.dispatch(UiActions.IsDesktop())), 0);
      }
    });
  }
}
